import script from "./ReviewCompanyDrawer.vue?vue&type=script&setup=true&lang=js"
export * from "./ReviewCompanyDrawer.vue?vue&type=script&setup=true&lang=js"

import "./ReviewCompanyDrawer.vue?vue&type=style&index=0&id=1cc37a93&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1cc37a93"]])

export default __exports__